import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaughWink, faClock, faTachometerAlt, faCog, faWrench, faFolder, faChartArea, faChevronRight,
faTable, faBowlFood, faUser, faCartShopping, faSignOutAlt, faBars , faCogs, faList,faEnvelope, faAddressBook} from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/images/logo_italianrest_transparent.png';
import profil from '../../assets/images/user-profile.png';
import { UserContext } from '../../contexts/UserContext';
import { Outlet } from 'react-router-dom';
import { collection, addDoc, updateDoc, doc , getDocs, getDoc,query, where } from 'firebase/firestore';
import { storage, db } from '../../firebase';
import { Timestamp } from 'firebase/firestore';


const AdminLayout = () => {

  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext); // Accéder au rôle utilisateur
  const { gerant, setGerant } = useContext(UserContext);
  
  const [isSidebarToggled, setIsSidebarToggled] = useState(false);
  const [ordersEnabled, setOrdersEnabled] = useState(true); // État pour savoir si les commandes sont activées ou non

  const handleSidebarToggle = () => {
    setIsSidebarToggled(!isSidebarToggled);
  };

  useEffect(() => {
    // Vérifie la taille de l'écran pour ajuster la visibilité de la barre latérale
    const checkScreenSize = () => {
      if (window.innerWidth <= 1000) {
        setIsSidebarToggled(true); // Visible sur mobile
      } else {
        setIsSidebarToggled(false); // Caché sur écran plus grand
      }
    };

    // Exécute une première vérification à l'initialisation
    checkScreenSize();

    // Écoute les changements de taille de l'écran
    window.addEventListener('resize', checkScreenSize);

    // Nettoyage à la destruction du composant
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);


    // Charger l'état des commandes depuis Firestore
    useEffect(() => {
      const fetchOrderStatus = async () => {
        const docRef = doc(db, 'config', 'orderStatus'); // Référence à votre document Firestore
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setOrdersEnabled(docSnap.data().accept_commandes); // Charger l'état des commandes
        } else {
          console.log("Aucun statut de commande trouvé !");
        }
      };
      fetchOrderStatus();
    }, []);

 

    
    const toggleOrders = async () => {
      const newStatus = !ordersEnabled;
      setOrdersEnabled(newStatus);
  
      const docRef = doc(db, 'config', 'orderStatus');
      await updateDoc(docRef, {
        accept_commandes: newStatus
      });
  
     
    };

  const handleLogout = () => {
    // Supprimer les données utilisateur du localStorage ou du contexte
    localStorage.removeItem('user');
    setUser(null);
    localStorage.removeItem('gerant');
    setGerant(null);
    navigate('/login'); // Rediriger vers la page de connexion
  };

  return (
    
      
    <div id="wrapper">
    <ul className={`navbar-nav bg-black sidebar sidebar-dark accordion  ${isSidebarToggled ? 'toggled' : 'collapsed'}`} id="accordionSidebar">
      <Link className="d-flex align-items-center justify-content-center p-3" to="/admin">
        <img className="logo-sidebar" src={logo} alt="Chez Papy"/>
      </Link>

      <hr className="sidebar-divider my-0" />

      <li className="nav-item active">
        <Link className="nav-link" to="/index.html">
          <FontAwesomeIcon icon={faTachometerAlt} />
          <span>Dashboard</span>
        </Link>
      </li>

      <hr className="sidebar-divider" />

      {(user  || user && gerant) && (
        <div>
          <div className="sidebar-heading">Commandes en ligne</div>

          <li className="nav-item">
            <Link className="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
              <FontAwesomeIcon icon={faBowlFood} />
              <span>  Plats</span>
            </Link>
            <div id="collapse1" className="collapse visible-collapse" aria-labelledby="headingTwo">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/admin/Plats">Tous les plats</Link>
                <Link className="collapse-item" to="/admin/AddPlat">Ajouter un nouveau</Link>
                <Link className="collapse-item" to="/admin/Categories">Catégories</Link>
                <Link className="collapse-item" to="/admin/Addons">Addons</Link>
              </div>
            </div>
          </li>

          <li className="nav-item">
            <Link className="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
              <FontAwesomeIcon icon={faUser} />
              <span>  Comptes</span>
            </Link>
            <div id="collapse2" className="collapse visible-collapse" aria-labelledby="headingTwo">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/admin/Users">Tous les comptes</Link>
                <Link className="collapse-item" to="/admin/Roles">Rôles</Link>
              </div>
            </div>
          </li>
          <li className="nav-item">
            <Link className="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
              <FontAwesomeIcon icon={faTable} />
              <span>  Commandes</span>
            </Link>
            <div id="collapse3" className="collapse visible-collapse" aria-labelledby="headingThree">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/admin">Toutes les Commandes</Link>
                <Link className="collapse-item" to="/admin/Promos">Codes de réductions</Link>
              </div>
            </div>
          </li>
          <li className="nav-item">
          <Link className="nav-link" to="/admin/Reservations">
          <FontAwesomeIcon icon={faAddressBook} />
            <span>  Reservations</span>
          </Link>
        </li>
          {/* <li className="nav-item">
          <Link className="nav-link" to="/admin/Panier">
            <FontAwesomeIcon icon={faCartShopping} />
            <span>  Panier</span>
          </Link>
        </li> */}
        <li className="nav-item">
         
        </li>
        <li className="nav-item">
            <Link className="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
            <FontAwesomeIcon icon={faClock} />
              <span>  Horaires</span>
            </Link>
            <div id="collapse6" className="collapse visible-collapse" aria-labelledby="headingThree">
              <div className="bg-white py-2 collapse-inner rounded">
              <Link className="collapse-item" to="/admin/horairesOuverture">
                <span>  Heures d'ouverture</span>
              </Link>
              <Link className="collapse-item" to="/admin/JoursFermeture">
                  <span>  Fermetures programmées</span>
                </Link>
              </div>
            </div>
          </li>
          <li className="nav-item">
          <Link className="nav-link" to="/admin/Email">
          <FontAwesomeIcon icon={faEnvelope} />
            <span>  Email</span>
          </Link>
        </li>
        </div>
      )}

{(gerant  && !user) && (
        <div>
          <div className="sidebar-heading">Commandes en ligne</div>

          <li className="nav-item">
            <Link className="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
              <FontAwesomeIcon icon={faBowlFood} />
              <span>  Plats</span>
            </Link>
            <div id="collapse1" className="collapse visible-collapse" aria-labelledby="headingTwo">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/gerant/Plats">Tous les plats</Link>
                <Link className="collapse-item" to="/gerant/Addons">Addons</Link>
              </div>
            </div>
          </li>

          <li className="nav-item">
            <Link className="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
              <FontAwesomeIcon icon={faUser} />
              <span>  Comptes</span>
            </Link>
            <div id="collapse2" className="collapse visible-collapse" aria-labelledby="headingTwo">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/gerant/Users">Tous les comptes</Link>
                <Link className="collapse-item" to="/gerant/Roles">Rôles</Link>
              </div>
            </div>
          </li>
          <li className="nav-item">
            <Link className="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
              <FontAwesomeIcon icon={faTable} />
              <span>  Commandes</span>
            </Link>
            <div id="collapse3" className="collapse visible-collapse" aria-labelledby="headingThree">
              <div className="bg-white py-2 collapse-inner rounded">
                <Link className="collapse-item" to="/gerant">Toutes les Commandes</Link>
                <Link className="collapse-item" to="/gerant/Promos">Codes de réductions</Link>
              </div>
            </div>
          </li>
          <li className="nav-item">
          <Link className="nav-link" to="/gerant/Reservations">
          <FontAwesomeIcon icon={faAddressBook} />
            <span>  Reservations</span>
          </Link>
        </li>
          {/* <li className="nav-item">
          <Link className="nav-link" to="/gerant/Panier">
            <FontAwesomeIcon icon={faCartShopping} />
            <span>  Panier</span>
          </Link>
        </li> */}
        <li className="nav-item">
            <Link className="nav-link collapsed" data-bs-toggle="collapse" data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
            <FontAwesomeIcon icon={faClock} />
              <span>  Horaires</span>
            </Link>
            <div id="collapse6" className="collapse visible-collapse" aria-labelledby="headingThree">
              <div className="bg-white py-2 collapse-inner rounded">
              <Link className="collapse-item" to="/gerant/horairesOuverture">
                <span>  Heures d'ouverture</span>
              </Link>
              <Link className="collapse-item" to="/gerant/JoursFermeture">
                  <span>  Fermetures programmées</span>
                </Link>
              </div>
            </div>
          </li>
          <li className="nav-item">
          <Link className="nav-link" to="/gerant/Email">
          <FontAwesomeIcon icon={faEnvelope} />
            <span>  Email</span>
          </Link>
        </li>
        </div>
      )}

      

      <hr className="sidebar-divider" />

      <div className="sidebar-heading">Addons</div>

      <hr className="sidebar-divider d-none d-md-block" />

      <li className="nav-item">
        <Link className="nav-link" to="#" onClick={handleLogout}>
          <FontAwesomeIcon icon={faSignOutAlt} />
          <span> Déconnexion</span>
        </Link>
      </li>
      <hr className="sidebar-divider d-none d-md-block" />
      <div className="text-center d-none d-md-inline">
        <button
          className="rounded-circle border-0"
          id="sidebarToggle"
          onClick={handleSidebarToggle} // Gère le clic sur le bouton
        > <FontAwesomeIcon icon={faChevronRight} /></button>
      </div>

    </ul>





    <div id="content-wrapper" className="d-flex flex-column">
      <div id="content">
          <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
       
      <button id="sidebarToggleTop" className="btn btn-menu d-md-none rounded-circle mr-3" onClick={handleSidebarToggle}>
        <FontAwesomeIcon icon={faBars} />
      </button>

              <ul className="navbar-nav ml-auto">

              <li className="nav-item dropdown no-arrow d-flex align-items-center">
  <button 
    onClick={toggleOrders} 
    className={`btn mx-auto ${ordersEnabled ? 'btn-danger' : 'btn-success'}`} 
  >
    {ordersEnabled ? 'Désactiver les commandes' : 'Activer les commandes'}
  </button>
</li>


                  <li className="nav-item dropdown no-arrow">
                      <a className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          {(user) && (<span className="mr-2  d-lg-inline text-gray-600 small">{user.nom}</span>)}
                          {(gerant) && (<span className="mr-2  d-lg-inline text-gray-600 small">{gerant.nom}</span>)}
                          <img className="img-profile rounded-circle" src={profil} alt="Profile" />
                      </a>
                      
                  </li>
              </ul>
          </nav>
        <Outlet /> {/* This will render the matched child route */}
      </div>
    </div>
  </div>
   
  
);
  
};

export default AdminLayout;
